import { getColor } from "../color";
export function Euro({ size = 14, color = "blue" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 14 15"
      fill={getColor(color) || color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_84_635)">
        <path
          d="M7.00002 0.25C3.1391 0.25 0 3.3891 0 7.25002C0 11.1109 3.1391 14.25 7.00002 14.25C10.8609 14.25 14 11.1109 14 7.25002C14 3.3891 10.8609 0.25 7.00002 0.25ZM7.00002 13.1004C3.77293 13.1004 1.14962 10.4771 1.14962 7.25002C1.14962 4.02293 3.77293 1.39962 7.00002 1.39962C10.2271 1.39962 12.8504 4.02293 12.8504 7.25002C12.8504 10.4771 10.2271 13.1004 7.00002 13.1004Z"
          fill={getColor(color) || color}
        />
        <path
          d="M7.60446 9.63736C7.04434 9.6224 6.45487 9.3576 6.11574 8.70882H7.86914V7.58858H5.8353C5.82033 7.48554 5.82033 7.36753 5.82033 7.24952C5.82033 7.11712 5.8353 6.99911 5.8353 6.86612H7.86914V5.76086H6.14507C6.48414 5.14203 7.05864 4.87664 7.61876 4.84729C8.03151 4.86226 8.42929 4.99466 8.76835 5.21571L9.28414 4.18413C8.79771 3.90436 8.25256 3.74202 7.67812 3.72705H7.57507C7.13297 3.74202 6.73519 3.83009 6.38115 4.00682C5.99776 4.19851 5.67366 4.46389 5.40828 4.80237C5.2022 5.08214 5.02489 5.39185 4.90746 5.76027H3.9939V6.86553H4.70138C4.68642 6.99794 4.68642 7.11594 4.68642 7.24893C4.68642 7.36694 4.70138 7.46998 4.70138 7.58799H4.00887V8.70823H4.92244C5.04045 9.07665 5.21717 9.40075 5.42326 9.6811C5.68864 10.0346 6.01273 10.2999 6.39612 10.4767C6.74957 10.6534 7.14794 10.7564 7.59005 10.7714H7.63437H7.69309C8.26759 10.7564 8.82771 10.5797 9.31415 10.2999L8.79836 9.28332C8.41496 9.48998 8.01661 9.62296 7.60443 9.63735L7.60446 9.63736Z"
          fill={getColor(color) || color}
        />
      </g>
      <defs>
        <clipPath id="clip0_84_635">
          <rect
            width={size}
            height={size}
            fill={getColor(color) || color}
            transform="translate(0 0.25)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
